export const IOS_APP_DOWNLOAD_URL =
  "https://apps.apple.com/us/app/zests-share-your-world/id6746111774";
export const ANDROID_APP_DOWNLOAD_URL =
  "https://play.google.com/store/apps/details?id=com.lifeagents.lifeinfo";
